import { useCallback, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/lamka";
import { useAuth } from "@/context/AuthContext";

const flip = (it) => ({ ...it, is_liked: !it.is_liked, likes_count: Math.max(0, (it.likes_count || 0) + (it.is_liked ? -1 : 1)) });

export const useLikeToggle = (setItems, { removeOnUnlike = false } = {}) => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const pending = useRef(new Set());

  return useCallback(
    async (item) => {
      if (!user) {
        toast("Sign in to save items");
        return navigate("/login");
      }
      if (pending.current.has(item.id)) return;
      pending.current.add(item.id);
      const liking = !item.is_liked;
      setItems((list) =>
        removeOnUnlike && !liking ? list.filter((x) => x.id !== item.id) : list.map((x) => (x.id === item.id ? flip(x) : x))
      );
      try {
        if (liking) await api.post(`/listings/${item.id}/like`);
        else await api.delete(`/listings/${item.id}/like`);
        toast(liking ? "Saved to your wishlist" : "Removed from your wishlist");
      } catch {
        setItems((list) =>
          removeOnUnlike && !liking ? [item, ...list] : list.map((x) => (x.id === item.id ? item : x))
        );
        toast.error("Couldn't update your wishlist. Please try again.");
      } finally {
        pending.current.delete(item.id);
      }
    },
    [user, navigate, setItems, removeOnUnlike]
  );
};
